import { useAuth } from '@/lib/auth/auth';
import type { VenueFollowersResponse } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const venueFollowerKeys = {
  all: ['venue-followers'] as const,
  list: (id: string) => [...venueFollowerKeys.all, id] as const,
};

export function useVenueFollowers(id?: string | null, enabled = true) {
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: id ? venueFollowerKeys.list(id) : venueFollowerKeys.all,
    enabled: Boolean(id) && enabled,
    queryFn: () => {
      if (!id) {
        throw new Error('Missing venue id');
      }
      return request<VenueFollowersResponse>(`/venues/${id}/followers`);
    },
    staleTime: 30_000,
  });
}
